import PropTypes from 'prop-types';
import { Children } from 'react';
import withSideEffect from 'react-side-effect';

const HtmlClassName = props => Children.only(props.children);

HtmlClassName.propTypes = {
  // eslint-disable-next-line
  className: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
    PropTypes.array,
  ]),
};

const reducePropsToState = propsList => propsList.map(props => props.className).join(' ');

const handleStateChangeOnClient = function handleStateChangeOnClient(className) {
  document.documentElement.className = className;
};

export default withSideEffect(reducePropsToState, handleStateChangeOnClient)(HtmlClassName);



// WEBPACK FOOTER //
// ./src/components/HtmlClassName.js